import React from 'react'
import { useHistory, Link as ReactRouterLink } from 'react-router-dom'
import { useAnalytics, useAuth, useModals } from 'hooks'
import { Box, FlexColumn, SubnavButton } from 'elements'
import SwitchOrgsModal from 'components/organization/switch/SwitchOrgsModal'

const Divider = () => <Box my="small" height="xxsmall" bg="background.1" />

export default function UserMenu() {
  const analytics = useAnalytics()
  const history = useHistory()
  const { user, currentOrg } = useAuth()
  const { openModal } = useModals()

  const trackMenuPress = (item) => analytics.track('User Menu Item Selected', { item })

  const handleLogOut = () => {
    trackMenuPress('logout')
    history.push('/auth/logout')
  }

  const handleSwitchOrganizations = () => {
    trackMenuPress('Switch Organization')
    openModal(SwitchOrgsModal, {}, 'full')
  }

  return (
    <FlexColumn p="medium" borderRadius="xsmall" bg="background.0" boxShadow="medium" width="236px">
      {user.organizationUsers.totalCount > 1 ? (
        <>
          <SubnavButton justifyContent="center" onClick={handleSwitchOrganizations}>
            Switch Firm
          </SubnavButton>
          <Divider />
        </>
      ) : null}
      <SubnavButton
        as="a"
        href="https://scrutinize.freshdesk.com/support/home"
        target="_blank"
        justifyContent="center"
        mb="xxsmall"
      >
        Need Help?
      </SubnavButton>
      <SubnavButton
        as="a"
        href="https://scrutinize.freshdesk.com/support/solutions/articles/150000000453-what-do-each-of-the-anomalies-and-metadata-types-mean-"
        target="_blank"
        justifyContent="center"
      >
        Anomaly Info
      </SubnavButton>
      <Divider />
      {currentOrg && (
        <SubnavButton
          as={ReactRouterLink}
          justifyContent="center"
          to={{ pathname: `/orgs/${currentOrg.slug}/settings` }}
        >
          Settings
        </SubnavButton>
      )}
      <SubnavButton justifyContent="center" onClick={handleLogOut}>
        Log Out
      </SubnavButton>
    </FlexColumn>
  )
}
